import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {MinMaxStoreForm} from '../../../../Models/Warehouse/Stocks/min-max-store.model';
import {StockFilters} from '../../../../Models/Warehouse/Stocks/stock-filters.model';
import {StocksModelService} from '../../../Models/Warehouse/Stocks/stocks-model.service';
import {StockProductDto} from '../../../../Models/Warehouse/Stocks/stock.interface';
import {StocksProductStoreForm} from '../../../../Models/Warehouse/Stocks/stocks-product-store.model';
import {TransferStockForm} from '../../../../Models/Warehouse/Transfers/transfer-stock.model';
import {TransferStockProductForm} from '../../../../Models/Warehouse/Transfers/transfer-stock-product.model';

@Injectable({
  providedIn: 'root'
})
export class StocksApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: StocksModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener el stock
   *
   */
  public getStock(params: StockFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getStockNew', params).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Eliminar stock
   *
   */
  public deleteProductStock(params: TransferStockProductForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteProductoAlmacen', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Editar el stock mínimo y máximo
   *
   */
  public setMinMaxStock(params: MinMaxStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setConfigAlmacen', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Añadir producto al stock
   *
   */
  public addProductToStock(params: StocksProductStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setProductoAlmacen', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar el orden de los productos
   *
   */
  public reorderProducts(params: { orden: StockProductDto[] }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('reorderStocks', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Transferir stock
   *
   */
  public transferStock(params: TransferStockForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setTraspaso', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
